import { gql } from "@apollo/client";

export const FETCH_MY_SCHOOLS = gql`
  query fetchMySchools($asRegularUser: Boolean) {
    fetchMySchools(asRegularUser: $asRegularUser) {
      documentId
      name
      code
      logoMAT {
        url
        alternativeText
      }
      subscription {
        name
        knowledgeBase
        learn
        search
        bookmark
        mission
        podcast
        resourceHub
      }
    }
  }
`;
